import { Chip } from "@mui/material";
import type { ChipProps } from "@mui/material";

export function AppBadge(props: ChipProps) {
  return <Chip size="small" variant="filled" {...props} />;
}
